import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/core/helpers/auth.service';

declare var $: any;

@Component({
  selector: 'loyaltic-feedback-success',
  templateUrl: './feedback-success.component.html',
  styleUrls: ['./feedback-success.component.scss']
})
export class FeedbackSuccessComponent implements OnInit {

  status: string = '';
  isLoggedIn = false;

  @ViewChild('feedbackSuccess', { static: false }) feedbackSuccessRef: any;
  @ViewChild('feedbackFailure', { static: false }) feedbackFailureRef: any;

  loading = false;
  public modalRef!: BsModalRef;

  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };

  constructor(
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router
    ) {
      this.isLoggedIn = authService.IsLoggedIn()
  }

  ngOnInit() {

  }

  goToHome() {
    this.modalRef.hide();
    this.router.navigate(['']);
  }



  ngAfterViewInit() {
    
    this.modalRef = this.modalService.show(this.feedbackSuccessRef, this.popupConfig);

    // open feedback falure modal popup in
    this.route.queryParams
      .filter(params => params.status)
      .subscribe(params => {
        //console.log(params); // { status: "failure/success" }
        this.status = params.status;
        //console.log(this.status); // failure/success

        //Show feedback success in modal
        if(this.status === 'failure') {
          this.modalRef = this.modalService.show(this.feedbackFailureRef, this.popupConfig);
        }
        // else {
        //   this.modalRef = this.modalService.show(this.feedbackSuccessRef, this.popupConfig);
        // }
      }
    );


  }


}
